var _Styled$Hr, _Styled$Hr2;
import clsx from 'clsx';
import * as React from 'react';
import * as Styled from './Divider.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Divider = /*#__PURE__*/React.forwardRef(function Divider({
  children,
  className,
  ...props
}, ref) {
  return /*#__PURE__*/_jsxs(Styled.Root, {
    ref: ref,
    role: "separator",
    className: clsx('ovpn-divider', className),
    ...props,
    children: [_Styled$Hr || (_Styled$Hr = /*#__PURE__*/_jsx(Styled.Hr, {
      className: "ovpn-divider-hr"
    })), children && children, children && (_Styled$Hr2 || (_Styled$Hr2 = /*#__PURE__*/_jsx(Styled.Hr, {
      className: "ovpn-divider-hr"
    })))]
  });
});
export default Divider;